/**
 * Cost Type Enum
 *
 * Defines the different types of costs that can be associated with an investment.
 */
export const CostTypeLabel = {
    software: 'Software/Tools/Licenses',
    contractor: 'Contractor/External Labor',
    employee: 'Employee/Headcount',
    service: 'Services',
    audit: 'Audit/Compliance',
    infrastructure: 'Infrastructure/Hosting',
    other: 'Other',
};
export const CostTypeDescription = {
    software: 'Systems, tools, or software licenses',
    contractor: 'External labor via SOW or recurring contracts',
    employee: 'Internal employees (salary or hourly)',
    service: 'Operational services consumed by the business',
    audit: 'Security, compliance, or other audits',
    infrastructure: 'Cloud hosting, technology spend, or platform costs',
    other: 'Other cost types not covered above',
};
export const COST_TYPES = [
    'software',
    'contractor',
    'employee',
    'service',
    'audit',
    'infrastructure',
    'other',
];
//# sourceMappingURL=cost-type.enum.js.map